var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as _ from 'lodash';
import * as React from 'react';
import { withRouter } from 'react-router-dom';
import ApiRequests from '../../../classes/http/ApiRequests';
import HttpRequests from '../../../classes/http/HttpRequests';
import AppRoutes from '../../../config/appRoutes';
import Grid from '../../UI/Grid/Grid';
var TemplateList = /** @class */ (function (_super) {
    __extends(TemplateList, _super);
    function TemplateList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new ApiRequests();
        _this.http = new HttpRequests();
        _this.gridHeaders = [
            { name: 'Име', key: 'bg_name', filter: false, sort: false },
            { name: 'Шаблон', key: 'nameTemplate', filter: false, sort: false },
        ];
        _this.onPage = function (event) {
            _this.props.getAllTemplates(event.page + 1);
        };
        _this.editTemplate = function (rowItem) {
            var selectedId = _.get(rowItem, 'id', '0');
            if (selectedId !== '0') {
                _this.props.history.push(AppRoutes.editTemplate.path.replace(':id', selectedId));
            }
        };
        _this.deleteTemplate = function (rowItem) {
            var selectedId = _.get(rowItem, 'id', '0');
            var ask = confirm("\u041D\u0430\u0438\u0441\u0442\u0438\u043D\u0430 \u043B\u0438 \u0438\u0441\u043A\u0430\u0442\u0435 \u0434\u0430 \u0438\u0437\u0442\u0440\u0438\u0435\u0442\u0435 \u0437\u0430\u043F\u0438\u0441\u0430?");
            if (ask) {
                _this.api
                    .deleteTemplate(selectedId)
                    .then(function (response) {
                    // Delete the item from the state of the parent component
                    _this.props.deleteItem(selectedId);
                })
                    .catch(function (error) {
                    _this.http.handleError(error, _this.props.messages, 'Записът не бе изтрит. Моля, опитайте отново.', _this.props.history);
                });
            }
        };
        return _this;
    }
    TemplateList.prototype.render = function () {
        var gridData = this.props.gridData;
        return (React.createElement(Grid, { data: gridData, columns: this.gridHeaders, emptyMessage: "", paginator: true, lazy: true, editAction: this.editTemplate, onPage: this.onPage, deleteAction: this.deleteTemplate }));
    };
    return TemplateList;
}(React.Component));
// @ts-ignore
export default withRouter(TemplateList);



//////////////////
// WEBPACK FOOTER
// ./src/components/Template/TemplateList/TemplateList.tsx
// module id = 491
// module chunks = 0